import { render, staticRenderFns } from "./SituationRow.vue?vue&type=template&id=2cd83bc4&scoped=true"
import script from "./SituationRow.vue?vue&type=script&lang=js"
export * from "./SituationRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd83bc4",
  null
  
)

export default component.exports